import { environment } from '../../environments/environment';

/** Maintain control of which functionalities should be shown or hidden */
export const feature = {
  /** Google Analytics */
  googleAnalytics: environment.production,

  /** Translations */
  translations: environment.local || environment.dev,

  /** Show developer helprer */
  developerHelper: !environment.production,

  /** Eina integrations (Honda, MTR...) */
  integrations: true,

  /** Frontend documentation */
  forntendDocu: !environment.production,

  /** Open dialogs like 'WelcomeComponent' or 'DragTutorialComponent' */
  openDialogs: !environment.production,

  /** Tracking user actions */
  logRocket: false /** Logrocket no funciona con Angular 21 */,

  /** Tracking user actions */
  clarity: environment.production,

  /** Report errors to Jira */
  reportLogs: environment.production,

  /** Report errors to Jira */
  toJira: environment.production,

  exports: false, //cuidado con generic-export.component.html

  /** Tariff */
  tariff: environment.local,

  /** Colors (VN, VO) */
  colors: false,

  /** Widgets available on all documents */
  widgetsAllDocuments: false,

  /** For testing finished user subbscrioption or trail end */
  imTestingSubscriptionOrTrialEnd: false,

  /** Chat interno */
  chatInternal: true,
};
